import { PageHead } from '../../components/primitives/PageHead'
import { AdminBackgroundJobsTab } from './AdminBackgroundJobsTab'

/** Standalone admin page (`/admin/jobs`) — runtime control for managed
 *  background jobs. Reuses the AdminBackgroundJobsTab body; route + sidebar
 *  entry gate access on admin+ and the adminBackgroundJobs flag. */
export function AdminBackgroundJobsPage(): JSX.Element {
  return (
    <>
      <PageHead
        eyebrow="Admin"
        title="Background jobs"
        subtitle="Pause or resume background jobs and digest notifications, and re-pace the schedulable ones."
      />
      <AdminBackgroundJobsTab />
    </>
  )
}
